import React, {
  Fragment,
  createContext,
  Suspense,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState
} from 'react';
import { Router, Link, Location } from '@reach/router';
import Layout from '../components/Layout/Layout';
import ErrorBoundary from '../hoc/ErrorBoundary/ErrorBoundary';
import { getToken, onMessageListener } from '../common/Firebase/Firebase';
const LeadProfile = React.lazy(() =>
  import('../containers/LeadProfile/LeadProfile')
);
const BPList = React.lazy(() => import('../common/components/BPList/BPList'));
const Logout = React.lazy(() => import('../common/components/Logout/Logout'));
const genericDashboard = React.lazy(() =>
  import('../LazyNamedExport/DefaultDashBoard')
);
const comingSoonPage = React.lazy(() =>
  import('../LazyNamedExport/ComingSoonPage')
);
const RedirectToDashboard = React.lazy(() =>
  import('../LazyNamedExport/RedirectToDashboard')
);
const RedirectToPartnerProfilePage = React.lazy(() =>
  import('../LazyNamedExport/RedirectToPartnerProfilePage')
);
const Settings = React.lazy(() => import('../LazyNamedExport/Settings'));
const PrivateRoute = React.lazy(() =>
  import('../common/PrivateRoute/PrivateRoute')
);
import { navigate } from 'gatsby';
import DeviceDetector from 'device-detector-js';

import {
  RequestCreditReport,
  PersonalDiscussionForm,
  PDViewOnly,
  TeamPerformance,
  BankPerformance,
  PLStatement,
  CommissionBankUnitWise,
  IndividualPerformance,
  BankDisbursementReport,
  BankSlabPerformance,
  CallLog,
  CallReport,
  MessageContainer,
  FunnelReport,
  LeadReflexReport,
  UserKycSteps,
  Resource,
  LeadProfileDocView,
  PropertyDetailSteps,
  CallDetails,
  kyc,
  IncomeStarter,
  LapStarter,
  IncomeSteps,
  SEP,
  IncomeDetailsLap,
  CompanyDetailsSteps,
  PropertyDetailsSteps,
  MobileBPDashboard,
  SENPIncomeDeatils,
  CMDocView,
  RegistrationHomepage,
  RequestDocument,
  Loader as CircularLoading,
  AddleadSteps,
  LeadMissedCallReport,
  ManuallyAddBankStatement,
  DisbursementUI,
  PropertyStarterFlow,
  BRE,
  BREKYC,
  CompanyGrading,
  CompanyProfile,
  AllowedIndustry
} from '@fincity-frontend/shared-ui';

import { enableCommissionBonus, serviceWorkerFile } from 'gatsby-env-variables';
import { isLoggedIn } from '../common/utils/cookie-utils';
import {
  webSocketConnection,
  isAliveWebSocket
} from '../common/webSocket/WebSocket';
import { socketData } from '../common/webSocket/webSocketData';
import NotificationDataContext from '../common/Context/NotificationDataContext';
import TopHeaderForNotification from '../common/components/TopHeaderForNotification/TopHeaderForNotification';
import { getFcm, setFcm } from '../common/utils/firebase-utils';
import {
  initiaizeFB,
  isFcmServiceWorkerActive
} from '../common/Firebase/Firebase';
import ComingSoonPage from '../LazyNamedExport/ComingSoonPage';

const Commissions = React.lazy(() =>
  import('../LazyNamedExport/CommissionsPage')
);
const FIDashboard = React.lazy(() => import('../containers/FIDashboard/index'));

const socketMessageList = {};

export const setSocketMessage = data => {
  if (data?.messageType === 'applicant_whatsapp_notification') {
    socketMessageList['wa_notification'] = [
      ...(socketMessageList?.wa_notification || []),
      data
    ];
  } else if (data?.messageType === 'applicant_calling_notification') {
    socketMessageList['call_notification'] = [
      ...(socketMessageList?.call_notification || []),
      data
    ];
  } else if (data?.messageType === 'unread_notification_count') {
    socketMessageList['count_notification'] = data;
  }
  try {
    socketMessageList?.hooksData?.setSocketMessages({ ...socketMessageList });
  } catch {}
};

export const DeveloperDataContext = createContext({
  appData: { companyReload: false, bankReload: false, shouldUpload: false },
  setAppData: () => {}
});

const App = ({ location }) => {
  const [isFront, setIsFront] = useState(false);
  const [isAuth, setIsAuth] = useState(isLoggedIn());
  const [globalLevelCall, setGlobalCall] = useState(true);
  const [socketMessages, setSocketMessages] = useState({});
  const [firebaseToken, setFirebaseToken] = useState();
  const [deviceInfo, setDeviceInfo] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [showNotificationHeader, setShowNotificationHeader] = useState(false);
  const [
    notificationHeaderMessage,
    setShowNotificationHeaderMessage
  ] = useState('');

  const [appData, setAppData] = useState({
    companyReload: false,
    bankReload: false,
    shouldUpload: false
  });

  useLayoutEffect(() => {
    initiaizeFB();
  }, []);
  const getDeviceId = async () => {
    if (getFcm()?.deviceId) {
      return setDeviceId(getFcm()?.deviceId);
    } else if (typeof navigator !== `undefined`) {
      import('device-uuid').then(({ DeviceUUID }) => {
        var uuid = new DeviceUUID().get();
        setDeviceId(uuid);
        setFcm({ ...(getFcm() || {}), deviceId: uuid });
      });
    }
  };

  useEffect(() => {
    if (!isLoggedIn()) return;
    getDeviceId();
    const deviceDetector = new DeviceDetector();
    const userAgent = navigator.userAgent;
    const device = deviceDetector.parse(userAgent);
    setDeviceInfo(device);
    return () => {
      setDeviceId('');
      setDeviceInfo('');
      self.removeEventListener('install', () => {});
    };
  }, []);

  useEffect(() => {
    const fcmHandler = async () => {
      if (deviceId && deviceInfo) {
        onMessageListener();
        getToken({
          setFirebaseToken: setFirebaseToken,
          deviceInfo: deviceInfo,
          deviceId: deviceId,
          setShowNotificationHeader: setShowNotificationHeader,
          setShowNotificationHeaderMessage: setShowNotificationHeaderMessage
        });
      }
    };
    fcmHandler();
  }, [deviceId, deviceInfo]);

  useEffect(() => {
    socketMessageList['hooksData'] = {
      socketMessages: socketMessages,
      setSocketMessages: setSocketMessages
    };
    return () => {
      socketMessageList.length = 0;
    };
  }, []);

  useEffect(() => {
    process.nextTick(() => {
      if (globalThis.window ?? false) {
        setIsFront(true);
      }
    });
  }, []);
  if (!isFront) return null;

  if (isAuth && globalLevelCall && !isAliveWebSocket()) {
    setGlobalCall(false);
    let socket = new webSocketConnection();
    socket.connect(socketData({ socketInstance: socket }));
  }

  return (
    <Layout
      customTtle={location.pathname === '/app/commission' ? 'Dashboard FI' : ''}
    >
      <TopHeaderForNotification
        showNotificationHeader={showNotificationHeader}
        setShowNotificationHeader={setShowNotificationHeader}
        message={notificationHeaderMessage}
      />
      <div className="app flex bg-grey-950 min-h-screen  font-roboto text-sm font-normal m-0 p-0">
        {/* <Sidebar /> */}
        <Location>
          {({ location }) => (
            <React.Fragment>
              <NotificationDataContext.Provider value={socketMessages}>
                <DeveloperDataContext.Provider
                  value={{
                    appData,
                    setAppData
                  }}
                >
                  <ErrorBoundary>
                    <Suspense
                      fallback={<CircularLoading className="text-teal" />}
                    >
                      <Router
                        location={location}
                        basepath="/app"
                        className="w-full"
                      >
                        <PrivateRoute
                          exact
                          path="/leads"
                          component={comingSoonPage}
                        />
                        <PrivateRoute
                          exact
                          path="/leadprofile"
                          component={LeadProfile}
                        />
                        <PrivateRoute
                          exact
                          path="/invoicing"
                          component={comingSoonPage}
                        />
                        <PrivateRoute
                          exact
                          path="/UserKyc"
                          component={UserKycSteps}
                        />
                        <PrivateRoute
                          exact
                          path="/resource"
                          component={Resource}
                        />
                        <PrivateRoute
                          exact
                          path="/leadprofile/:typeleadprofile/:applicantId"
                          component={LeadProfileDocView}
                        />
                        <PrivateRoute
                          exact
                          path="/propertyDetails"
                          component={PropertyDetailSteps}
                        />
                        <PrivateRoute
                          exact
                          path="/commissions"
                          component={Commissions}
                        />
                        <PrivateRoute
                          exact
                          path="/performance_report"
                          component={comingSoonPage}
                        />
                        <PrivateRoute
                          exact
                          path="/call_details"
                          component={CallDetails}
                        />
                        <PrivateRoute
                          exact
                          path="/fcu"
                          component={comingSoonPage}
                        />
                        <PrivateRoute
                          exact
                          path="/business_targets"
                          component={comingSoonPage}
                        />
                        <PrivateRoute exact path="/kyc" component={kyc} />
                        <PrivateRoute
                          exact
                          path="/settings"
                          component={Settings}
                        />
                        <PrivateRoute
                          exact
                          path="/addlead"
                          component={AddleadSteps}
                        />
                        <PrivateRoute
                          exact
                          path="/addlead?leadId=leadId"
                          component={AddleadSteps}
                        />
                        <PrivateRoute
                          exact
                          path="/income"
                          component={IncomeStarter}
                        />
                        <PrivateRoute
                          exact
                          path="/income/salaried"
                          component={IncomeSteps}
                        />
                        <PrivateRoute
                          exact
                          path="/income/sep"
                          component={SEP}
                        />
                        <PrivateRoute
                          exact
                          path="/MobileBPDashboard"
                          component={MobileBPDashboard}
                        />
                        <PrivateRoute
                          exact
                          path="/documents/leadId/:leadId"
                          component={CMDocView}
                        />
                        <PrivateRoute exact path="/bp" component={BPList} />
                        <PrivateRoute
                          exact
                          path="/myprofile"
                          component={RedirectToPartnerProfilePage}
                        />
                        <PrivateRoute
                          exact
                          path="/basicdetails"
                          component={RedirectToDashboard}
                        />
                        <PrivateRoute
                          exact
                          path="/income/senp"
                          component={SENPIncomeDeatils}
                        />
                        <PrivateRoute exact path="/logout" component={Logout} />
                        <PrivateRoute
                          exact
                          path="/dashboard"
                          component={genericDashboard}
                        />
                        <PrivateRoute
                          exact
                          path="/LAP"
                          component={LapStarter}
                        />
                        <PrivateRoute
                          exact
                          path="/LAP/kyc"
                          component={CompanyDetailsSteps}
                        />
                        <PrivateRoute
                          exact
                          path="/LAP/property"
                          component={PropertyDetailsSteps}
                        />
                        <PrivateRoute
                          exact
                          path="/LAP/income"
                          component={IncomeDetailsLap}
                        />
                        <PrivateRoute
                          exact
                          path="/dashboard?status=calls"
                          component={genericDashboard}
                        />
                        <PrivateRoute
                          exact
                          path="/credit-report"
                          component={RequestCreditReport}
                        />
                        <PrivateRoute
                          path="/request-documents"
                          component={RequestDocument}
                        />
                        <PrivateRoute
                          path="/leadprofile/:typeleadprofile"
                          component={LeadProfileDocView}
                        />
                        <PrivateRoute
                          path="/cm/lead/:typeleadprofile"
                          component={LeadProfileDocView}
                        />
                        <PrivateRoute
                          exact
                          path="/dashboard/lead/pd"
                          component={PersonalDiscussionForm}
                        />
                        <PrivateRoute
                          exact
                          path="/dashboard/lead/view/pd/:redirect"
                          component={PDViewOnly}
                        />
                        <PrivateRoute
                          exact
                          path="/report/teamperformance"
                          component={TeamPerformance}
                        />
                        <PrivateRoute
                          exact
                          path="/bank_report"
                          component={comingSoonPage}
                        />
                        <PrivateRoute
                          exact
                          path="/report/bankperformance"
                          component={BankPerformance}
                        />
                        <PrivateRoute
                          exact
                          path="/pl_statement"
                          component={comingSoonPage}
                        />
                        <PrivateRoute
                          exact
                          path="/report/plstatement"
                          component={PLStatement}
                        />
                        <PrivateRoute
                          exact
                          path="/commission"
                          component={FIDashboard}
                        />
                        <PrivateRoute
                          exact
                          path="/report/performance"
                          component={IndividualPerformance}
                        />
                        <PrivateRoute
                          path="/commission/bank/:fiId/:brandName/:legalName"
                          component={CommissionBankUnitWise}
                          enableCommissionBonus={enableCommissionBonus}
                        />
                        <PrivateRoute
                          exact
                          path="/report/bank/disbursement"
                          component={BankDisbursementReport}
                        />
                        <PrivateRoute
                          exact
                          path="/report/bank/slab"
                          component={BankSlabPerformance}
                        />
                        <PrivateRoute
                          exact
                          path="/calllog/:leadId"
                          component={CallLog}
                        />
                        <PrivateRoute
                          exact
                          path="/report/call"
                          component={CallReport}
                        />
                        <PrivateRoute
                          exact
                          path="/report/call/logs"
                          component={CallLog}
                        />
                        <PrivateRoute
                          exact
                          path="/whatsapp"
                          component={MessageContainer}
                        />
                        <PrivateRoute
                          exact
                          path="/report/funnel"
                          component={FunnelReport}
                        />
                        <PrivateRoute
                          exact
                          path="/report/lead-reflex-report"
                          component={LeadReflexReport}
                        />
                        <PrivateRoute
                          exact
                          path="/report/lead-missed-call-report"
                          component={LeadMissedCallReport}
                        />
                        <PrivateRoute
                          exact
                          path="/applicant/bank-statement/:leadId/:applicantId/:docId"
                          component={ManuallyAddBankStatement}
                        />

                        <PrivateRoute
                          exact
                          path="/report/disbursement"
                          component={DisbursementUI}
                        />

                        <PrivateRoute
                          exact
                          path="/property"
                          component={PropertyStarterFlow}
                        />
                        <PrivateRoute exact path="/bre" component={BRE} />
                        <PrivateRoute
                          exact
                          path="/bre/kyc"
                          component={BREKYC}
                        />
                        <PrivateRoute
                          exact
                          path="/bre/industry"
                          component={AllowedIndustry}
                        />
                        <PrivateRoute
                          exact
                          path="/allcompany"
                          component={CompanyGrading}
                        />
                        <PrivateRoute
                          exact
                          path="/companyprofile/:id"
                          component={CompanyProfile}
                        />
                        <NotFound default />
                        <RegistrationHomepage path=":user/forgotpassword" />
                      </Router>
                    </Suspense>
                  </ErrorBoundary>
                </DeveloperDataContext.Provider>
              </NotificationDataContext.Provider>
            </React.Fragment>
          )}
        </Location>
      </div>
    </Layout>
  );
};

const NotFound = () => {
  navigate('/');
  return <Fragment />;
};

export default App;
